export default __webpack_public_path__ + "static/media/senior-sample3.ed4f6399.png";